import React, {useContext, useState, useRef} from 'react'
import {CartesianGrid, Legend, Line, LineChart, ReferenceLine, YAxis} from "recharts";
import { debugdiv, useMountEffect, ReadingsContext, DeviceContext } from '../ODevice';
import Measure from "react-measure";

const Graph = (props) => {
  const [debugvisible, setDebugvisible] = useState(true);
  const functionname ='Graph';
  const refDebugDiv = useRef();

    // Only run once while after mounting
    useMountEffect(()=>{
      console.log( functionname  + '  is loaded');
      if (debugvisible) {
        refDebugDiv.current.style.display = 'unset';
      } else {
        refDebugDiv.current.style.display = 'none';
      }
  });

  const handleChangeChkDebug = event =>{
    console.log('clicked');
    if (event.target.checked) {
        console.log('✅ Checkbox is checked');
        refDebugDiv.current.style.display = 'unset';
      } else {
        console.log('⛔️ Checkbox is NOT checked');
        refDebugDiv.current.style.display = 'none';
      }
      setDebugvisible(debugvisible => !debugvisible);
    };

  const context = useContext(DeviceContext);
  const readings = useContext(ReadingsContext);
  const [size, setSize] = useState({width: 0, height: 300});

  const config = context.config || {
    peakLimit: 0
  };

  const {
      peakLimit
  } = config;

  const {
    readings: data
  } = readings;

  return (
    
    <div style={debugdiv}>
                <div  style={debugdiv}>
                <input type="checkbox" defaultChecked={debugvisible} onChange={ handleChangeChkDebug } />&nbsp;
                <b>{ functionname }</b> 
            </div>
            <div ref={refDebugDiv} >
            <Measure bounds onResize={contentRect => setSize(contentRect.bounds)}>
              {({ measureRef }) => (
                <div style={{ height: 300 }} ref={measureRef}>
                  <LineChart width={size.width} height={size.height} data={data}>
                    <YAxis yAxisId={0} domain={[0, 4096]} />
                    <YAxis yAxisId={1} domain={[0, 255]} label={"%"} orientation={"right"} />
                    <Legend />
                    <CartesianGrid vertical={false} stroke={"#333333"} />
                    <ReferenceLine y={peakLimit} label={"Arousal Limit"} stroke={"#b71c1c"} />

                    <Line name="P" type={"monotone"} dataKey={"stream_1"} yAxisId={0} dot={false} stroke={"#81c784"} />
                    <Line name="M" type={"step"} dataKey={"stream_2"} yAxisId={1} dot={false} stroke={"#ffab40"} />
                    <Line name="A" type={"linear"} dataKey={"milliseconds"} strokeWidth={2} yAxisId={0} dot={false} stroke={"#ff3d00"} />
                  </LineChart>
                </div>
              )}
            </Measure>
            </div>

    </div>
  )
};

export default Graph
